import React from 'react'
import "./UserProfile.css";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ProfileSidebar from './ProfileSidebar';


export default function Preference() {
  return (
  <div className='user_profile_wrapper pt-4 pb-4'>
    <div className='container'>
       <div className='user_profile_subblock'>
          <div className='row'>
              <div className='col-md-3'>
                  <div className='sidebar_profile'>
                    <ProfileSidebar/>
                  </div>
              </div>
              <div className='col-md-9'>
              <div className='preference_right'>
              <div className='col-md-9 form_center '>
            <div className='domainpref_form_block'>
              <p className='fill_info_para'>Select any applicable Industry your business may need helps us provide more personalised product recommendations</p>
              <Form name="information" className="domainpref_form_info mt-4">
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Aerospace.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Aerospace</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Chemicals.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Chemicals</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Energy.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Energy</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Healthcare.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Healthcare</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Packaging.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Packaging, Construction</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Transportation.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Transportation</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Aerospace.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Banking</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Banking.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Food & Agri</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/InformationTechnology.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Information Technology</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='clearfix'></div>
                  <div className='col-md-6'>
                    <div className='see_all_ind'>
                      <p className='see_all_para'>Select all Industries </p>
                      <input type="checkbox" className='checkbox_co'/>
                    </div>
                  </div>
                 
                </div>
              </Form>
            </div>
        </div>
              </div>
              </div>
          </div>
      </div>
    </div>    
  </div>
  )
}
